import * as React from "react";
import { Session, Product, Sku } from "../types";
import { ProductCategory } from "../types-enums";
import { format } from "../utils";
import { Step } from "./step";
import t from "../i18n";
import Img from "../Controls/Img";
import { btnStyles } from "../_styles/button";
import { css } from "emotion";
import classNames from "classnames";

declare type BasketProps = {
    session: Session,
    selectedProduct: Product | undefined;
    selectedSku: Sku | undefined;
    step: Step;
    onNext: () => void;
}
export default class Basket extends React.Component<BasketProps> {
    renderWithBonusAndData() {
        const session = this.props.session;
        const selectedSku = this.props.selectedSku!;
        const hasBonus = !!selectedSku.bonusPercent;
        const hasData = !!selectedSku.bonusData;
        const totalLocalCurrencyAmount = selectedSku.localCurrencyAmount + selectedSku.bonusIncludingSalesTax;
        const pricing = <React.Fragment>
            <span>{format(session.faceValue, true)} {session.sourceCurrencyCode}</span>
            <i style={{ marginLeft: 5, marginRight: 5 }} className="fa fa-arrow-right" />
            <span>{totalLocalCurrencyAmount} {session.currencyCode}</span>
        </React.Fragment>;
        return <React.Fragment>
            <div className="d-none d-sm-block">
                <div>{t.basket("sending_to")} <br />+{session.internationalCode} {session.mobileNumber}</div>
                <div className="d-block d-md-none">{pricing}</div>
            </div>
            <div id="bonus-bucket" className="d-flex align-items-center justify-content-center">
                <Img className="d-none d-sm-inline" src="/images/veon/Present Box.png" style={{ height: 25, marginRight: 15 }} />
                {this.props.selectedProduct!.productCategory != ProductCategory.GiftCard && <div>
                    <div className="d-block d-sm-none">
                        <i className="fa fa-phone icon mr-1" />
                        +{session.internationalCode} {session.mobileNumber}
                    </div>
                    <div className="d-block d-sm-none">{pricing}</div>
                    {hasBonus && <div>
                        {t.basket("bonus_balance")} <span className="yellow-text">{selectedSku.bonusPercent}% {t.common("extra")}</span>
                    </div>}
                    {hasData && <div>
                        {t.basket("bonus_data")} <span className="yellow-text">{selectedSku.bonusData}</span>
                    </div>}
                    <div className="d-none d-sm-block yellow-text font-italic">{t.basket("valid_for", { bonusValidity: selectedSku.bonusValidity })}</div>
                </div>}
            </div>
            <div className="d-none d-md-flex align-items-center justify-content-center">
                <Img src="/images/veon/coins.png" style={{ height: 19 }} />
                <div style={{ marginLeft: 15 }}>{pricing}</div>
            </div>
        </React.Fragment>;
    }
    renderRegular() {
        const session = this.props.session;
        const selectedSku = this.props.selectedSku!;
        const totalLocalCurrencyAmount = selectedSku.localCurrencyAmount + selectedSku.bonusIncludingSalesTax;
        const pricing =
            <React.Fragment>
                <span>{format(session.faceValue, true)} {session.sourceCurrencyCode}</span>
                {session.faceValue !== totalLocalCurrencyAmount &&
                    <React.Fragment>
                        <i style={{ marginLeft: 5, marginRight: 5 }} className="fa fa-arrow-right" />
                        <span>{totalLocalCurrencyAmount} {session.currencyCode}</span>
                    </React.Fragment>}
            </React.Fragment>;
        return <React.Fragment>
            <div className="d-block">
                {this.props.selectedProduct!.productCategory != ProductCategory.GiftCard && <div>{t.basket("sending_to")} <br />+{session.internationalCode} {session.mobileNumber}</div>}
                <div className="d-block d-sm-none">{pricing}</div>
            </div>
            <div className="d-none d-sm-flex align-items-center justify-content-center">
                <Img src="/images/veon/coins.png" style={{ height: 19 }} />
                <div style={{ marginLeft: 15 }}>{pricing}</div>
            </div>
        </React.Fragment>;
    }
    render() {
        if (!this.props.selectedProduct || !this.props.selectedSku) return null;
        const product = this.props.selectedProduct;
        const selectedSku = this.props.selectedSku;
        if (!selectedSku) return null;
        const buttonText = this.props.step.current === "payment" ? t.common("pay") : t.common("next");
        const operatorUrl = product.operator.logoUrl;
        const hasBonus = !!selectedSku.bonusPercent;
        const hasData = !!selectedSku.bonusData;
        const renderType = hasBonus || hasData ? "bonus" : "regular";
        const maxWeidth = renderType === "regular" ? 768 : 992;
        return <div>
            {/* DO NOT DELETE following line. We need to add extra 70 pixel for footer */}
            <div style={{ height: 70 }} />
            <div className="footer">
                <div className="container-fluid small-gutter pr-lg-7 pl-lg-7 pr-md-5 pl-md-5" style={{maxWidth: maxWeidth}}>
                    <div className="d-flex align-items-center justify-content-between h-100">
                        <Img src={operatorUrl} style={{ height: 60 }} />
                        {renderType === "bonus" ? this.renderWithBonusAndData() : this.renderRegular()}
                        <a className={classNames(['button', css(btnStyles.default)])} onClick={this.props.onNext}>
                            {buttonText}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    }
}
